module.exports = __webpack_public_path__ + "static/media/aggregate.64b6ba5d.svg";